import { useDispatch, useSelector } from 'react-redux';
import { UsergroupAddOutlined } from '@ant-design/icons';

import RibbonButton from 'common/components/button/RibbonButton';

import gridSelector from 'common/components/grid-view/controllers/selectors';
import * as memberMaintenanceSelectors from 'pages/member-maintenance/controllers/selectors';

import { forwardTo } from 'utils/common/route';

const OpenTicketGroupMember = () => {
  const dispatch = useDispatch();

  const isMemberGridInfoView = useSelector(
    memberMaintenanceSelectors.selectIsMemberGridInfoView()
  );
  const selectedMemberMaintenanceDetail = useSelector(
    gridSelector.makeSelectDetailCurrentITemsSelection()
  );
  const memberMaintenanceId =
    selectedMemberMaintenanceDetail &&
    selectedMemberMaintenanceDetail.length > 0
      ? selectedMemberMaintenanceDetail[0].id
      : undefined;

  const onOpen = () => {
    forwardTo(`/ticket-group-assignment/member/${memberMaintenanceId}`);
  };

  return (
    <RibbonButton
      icon={<UsergroupAddOutlined style={{ height: 26 }} />}
      label={'Ticket Group'}
      onClick={onOpen}
      disabled={
        memberMaintenanceId === undefined ||
        selectedMemberMaintenanceDetail.length !== 1 ||
        !isMemberGridInfoView
      }
    />
  );
};

export default OpenTicketGroupMember;
